<template>
  <!-- He añadido la clase principal y el ID para ScrollTrigger -->
  <div class="portada-xv main-container" id="portada-xv" ref="rootRef" aria-label="Portada de XV">

    <!-- FLORES DECORATIVAS -->
    <!-- Se mantienen como elementos absolutos, pero ScrollTrigger los moverá sutilmente -->
    <img src="@/assets/petalos.png" class="flor flor-1 parallax-item" data-speed="0.1" alt="" />
    <img src="@/assets/petalos.png" class="flor flor-2 parallax-item" data-speed="-0.15" alt="" />
    <img src="@/assets/petalos.png" class="flor flor-3 parallax-item" data-speed="0.2" alt="" />

    <!-- 🦋 MARIPOSAS MAGICAS -->
    <!-- Animadas individualmente para un efecto más orgánico -->
    <img src="@/assets/mariposas.png" class="mariposa mariposa-1 magic-item" alt="" />
    <img src="@/assets/mariposas.png" class="mariposa mariposa-2 magic-item" alt="" />
    <img src="@/assets/mariposas.png" class="mariposa mariposa-3 magic-item" alt="" />
    <img src="@/assets/mariposas.png" class="mariposa mariposa-4 magic-item" alt="" />

    <!-- BOLA DISCO GIRANDO (Oculta por defecto en tu CSS, pero animada por si acaso) -->
    <!-- Nota: En tu CSS la bola-izquierda tiene z-index:9 y pointer-events:none, pero no background. Asegúrate que la imagen exista y se vea -->
    <img src="@/assets/mariposas.png" class="bola bola-izquierda" alt="" />

    <!-- RAMAS / PÉTALOS ADICIONALES (z-index bajo) -->
    <img src="@/assets/petalos.png" class="rama rama-der-baja2 parallax-item" data-speed="-0.1" alt="" />
    <img src="@/assets/petalos.png" class="rama rama-der-baja3 parallax-item" data-speed="0.1" alt="" />

    <!-- IMAGEN CON RECORTE LUXURY -->
    <!-- Este wrapper tendrá un efecto de paralelaje suave al scroll -->
    <div class="imagen-xv-wrapper photo-trigger">
      <img src="@/assets/DSC_5760_11zon.webp" class="imagen-xv" alt="Foto protagonista" />
    </div>

   <!-- TEXTO - Organizado para entrada consecutiva -->
    <section class="texto-xv text-stagger-container">
      <p class="frase-bendicion text-anim-item">
        Con la bendición de Dios y el amor de mi familia celebro un día que guardaré por siempre en mi corazón.<br /> <br /> 
      Mis padres:
      </p>

      <div class="separador-elegante text-anim-item"></div>

      <!-- Nombres de los padres -->
      <h1 class="nombre-protagonista text-anim-item">Gonzalo Garza Martinez</h1>
      <h1 class="nombre-protagonista text-anim-item">Edith Guadalupe Sabalza Rodriguez </h1>

      <!-- Sección de Padrinos con sus nombres 
      <div class="padrinos-container text-anim-item">
        <p class="frase-bendicion">Mis Padrinos:</p>
              <div class="separador-elegante text-anim-item"></div>

        <p class="nombre-protagonista"> Fidel Ibarra Salas</p>
<p class="nombre-protagonista"> Rosy González  Muñiz</p>        </div>
-->
      <p class="frase-bendicion text-anim-item"><br />
        Hay momentos que definen nuestra vida, quedando grabados en el alma y la memoria.
        Hoy experimento uno de esos instantes especiales y quiero compartirlo con quienes
        tienen un lugar en mi corazón.
      </p>
    </section>
  </div>
</template>

<script>
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'
// IMPORTANTE: Registrar ScrollTrigger
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'PortadaArley',
  setup() {
    const rootRef = ref(null)

    onMounted(async () => {
      await nextTick()

      // Selector optimizado
      const $ = (sel, context = rootRef.value) => gsap.utils.toArray(sel, context);

      const mainContainer = document.getElementById('portada-xv');
      const fotoWrapper = $('.imagen-xv-wrapper');
      const flores = $('.flor');
      const mariposas = $('.magic-item'); // Usando clase común
      const ramas = $('.rama');
      const textos = $('.text-anim-item'); // Usando clase común para el staggered
      const todosLosParallax = $('.parallax-item');


      // --- ESTADO INICIAL ---
      gsap.set([...fotoWrapper, ...flores, ...textos, ...ramas], { autoAlpha: 0, y: 35 });
      gsap.set(mariposas, { autoAlpha: 0, scale: 0.5, y: 50, filter: 'blur(2px)' });
      gsap.set('.separador-elegante', { scaleX: 0 }); // El separador crece horizontalmente


      // --- 1. ANIMACIÓN DE ENTRADA (CONSECUTIVA) ---
      // Usamos ScrollTrigger para disparar la Timeline cuando el contenedor es visible.
      const entryTL = gsap.timeline({
        scrollTrigger: {
          trigger: mainContainer,
          start: 'top 80%', // Dispara cuando el top del contenedor llega al 80% del viewport
          toggleActions: 'play none none none', // Solo se reproduce una vez
          once: true // Asegura que solo se ejecute una vez
        },
        defaults: { ease: 'power3.out', duration: 1 }
      });

      entryTL
        // 1.1 Entrada de la Foto (más suave y luxury)
        .fromTo(fotoWrapper, 
          { scale: 0.9, y: 60, filter: 'blur(8px)' },
          { autoAlpha: 1, scale: 1, y: 0, filter: 'blur(0px)', duration: 1.4 }
        )
        // 1.2 Entrada de Flores y Mariposas (casi simultánea, en cascada)
        .to(flores, { autoAlpha: 0.5, y: 0, stagger: 0.15 }, '-=0.9')
        .to(mariposas, { autoAlpha: 1, y: 0, scale: 1, filter: 'blur(0px)', stagger: 0.1, ease: 'back.out(1.7)' }, '-=0.8')
        // 1.3 Ramas de fondo
        .to(ramas, { autoAlpha: 0.4, y: 0, stagger: 0.2 }, '-=0.7')
        // 1.4 Entrada CONSECUTIVA de textos (incluye "Mis Padrinos")
        .to(textos, { 
          autoAlpha: 1, 
          y: 0, 
          stagger: 0.18, // Tiempo entre cada elemento de texto
          onComplete: () => {
            // Animar el separador específicamente al llegar su turno
            gsap.to('.separador-elegante', { scaleX: 1, duration: 0.8, ease: 'power2.inOut' });
          }
        }, '-=0.5');


      // --- 2. EXPERIENCIA HERMOSA AL SCRORLL (SCROLL-REACTIVE) ---
      // Esta es la clave para que "recalcule mientras baja".

      // 2.1 Sutil Paralelaje en la Foto (profundidad)
      gsap.to('.imagen-xv', {
        y: () => -window.innerHeight * 0.1, // Mueve la imagen un 10% de la altura de la pantalla hacia arriba
        ease: 'none',
        scrollTrigger: {
          trigger: '.photo-trigger',
          start: 'top bottom', // Empieza cuando la foto entra por abajo
          end: 'bottom top',   // Termina cuando la foto sale por arriba
          scrub: true // Sincroniza la animación directamente con el scroll (smooth scrub)
        }
      });

      // 2.2 Sutil Paralelaje en Elementos Decorativos (Flores y Ramas)
      todosLosParallax.forEach(item => {
        const speed = item.dataset.speed || 0.1;
        gsap.to(item, {
          y: () => -window.innerHeight * speed, // Cada elemento se mueve a su propia velocidad
          ease: 'none',
          scrollTrigger: {
            trigger: mainContainer,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true
          }
        });
      });

      // 2.3 Sutil desvanecimiento del texto superior mientras se baja
      gsap.to('.texto-xv', {
        autoAlpha: 0,
        y: -30,
        ease: 'none',
        scrollTrigger: {
          trigger: '.texto-xv',
          start: 'bottom 40%', // Empieza a desvanecerse cuando el fondo del texto está a 40% del top
          end: 'bottom top',   // Se desvanece totalmente al salir
          scrub: 1 // scrub con un pequeño lag para suavidad (1 segundo)
        }
      });


      // --- 3. MOVIMIENTO ORGÁNICO INFINITO (Se mantiene) ---
      ramas.forEach((r, i) => {
        gsap.to(r, {
          y: i % 2 === 0 ? '+=15' : '-=15', // Alternar dirección
          rotation: i % 2 === 0 ? '+=2' : '-=2', // Sutil rotación también
          duration: 4 + i, // Duraciones ligeramente diferentes para caos orgánico
          yoyo: true,
          repeat: -1,
          ease: 'sine.inOut'
        });
      });
      
      // Mariposas con sutil "vuelo" infinito
      mariposas.forEach((m, i) => {
        gsap.to(m, {
          x: '+=8',
          y: '-=10',
          duration: 3 + i,
          yoyo: true,
          repeat: -1,
          ease: 'sine.inOut',
          delay: i * 0.2
        });
      });

    });

    return { rootRef }
  }
}
</script>


<style scoped>
/* ESTILOS BASE (Mantenidos y limpiados) */
.portada-xv {
  position: relative;
  width: 100%;
  min-height: 100vh;
  /* El background fixed a veces da problemas en mobile, ScrollTrigger lo maneja mejor si es scroll */
  background:
    radial-gradient(ellipse at 50% 20%, rgba(255, 255, 255, 0.98), rgba(253, 242, 243, 0.99)),
    url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6"><rect width="6" height="6" fill="white"/><circle cx="3" cy="3" r="0.5" fill="%23f4eae9"/></svg>') repeat;
  background-attachment: scroll; /* ScrollTrigger se encarga de los efectos */
  overflow: hidden; /* Importante para que ScrollTrigger funcione bien con parallax */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 60px 20px 80px; /* Un poco más de espacio respirable */
  box-sizing: border-box;
}

/* MARCO FOTO (Se mantiene el look luxury) */
.imagen-xv-wrapper {
  width: min(92vw, 360px);
  height: calc(min(92vw, 360px) * 1.5);
  margin-top: 10px;
  border-radius: 180px 180px 0 0;
  overflow: hidden;
  z-index: 5; /* Por encima de las flores de fondo */
  background: #fff;
  box-shadow:
    0 15px 45px rgba(0,0,0,.15),
    0 4px 12px rgba(0,0,0,.05);
  will-change: transform, filter, opacity; /* Optimización */
}
.imagen-xv {
  width: 100%;
  height: 110%; /* Ligeramente más alta para el parallax interno */
  object-fit: cover;
  display: block;
  will-change: transform;
}

/* CONTENEDOR TEXTO */
.texto-xv {
  max-width: 620px;
  text-align: center;
  margin-top: 30px;
  padding: 0 10px;
  z-index: 10; /* Por encima de todo */
  will-change: transform, opacity;
}

/* ESTILOS DE TEXTO */
.frase-bendicion {
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.8vw, 22px);
  color: #3a3939;
  line-height: 1.6;
  margin: 0 0 15px;
}
.separador-elegante {
  width: 120px;
  height: 2px;
  margin: 15px auto 20px;
  background: linear-gradient(90deg, transparent, #e2cad5, transparent);
  border-radius: 2px;
  transform-origin: center; /* Para la animación de escala */
}
.nombre-protagonista {
  font-family: 'Playfair Display', serif;
  font-size: clamp(26px, 6vw, 38px);
  color: #eda3b2;
  margin: 0 0 10px 0;
  line-height: 1.1;
  font-weight: normal;
}

/* NUEVOS ESTILOS PARA PADRINOS */
.padrinos-container {
  margin: 25px 0 10px;
}
.titulo-padrinos {
  font-family: "Playfair Display", serif;
  font-size: clamp(20px, 3vw, 26px);
  color: #4a4949;
  font-weight: 600;
  margin-bottom: 10px;
}

.parrafo-presentacion {
  font-family: "quote", sans-serif; /* Asegúrate que esta font esté cargada */
  font-size: clamp(16px, 2.5vw, 17px);
  color: #4a4949;
  line-height: 1.8;
  margin-top: 15px;
}

/* ELEMENTOS DECORATIVOS (Mantenidos y optimizados) */
.flor, .rama, .mariposa, .bola {
  position: absolute;
  pointer-events: none;
  will-change: transform, opacity;
}

/* FLORES */
.flor {
  width: min(45vw, 250px);
  z-index: 2; /* Debajo de la foto wrapper */
  opacity: 0.5; /* Opacidad base para la entrada */
  filter: blur(0.5px) saturate(0.8);
}
.flor-1 { top: 10px; left: -80px; transform: scaleX(-1) rotate(45deg); width: min(55vw, 200px); opacity: 0.3; }
.flor-2 { top: 50px; right: -60px; transform: rotate(140deg); opacity: 0.25; }
.flor-3 { bottom: 10%; left: -100px; transform: rotate(-120deg); opacity: 0.4; }

/* MARIPOSAS */
.mariposa {
  width: min(15vw, 70px);
  z-index: 6; /* Ligeramente por encima de la foto o cerca */
  filter: blur(0.2px);
  opacity: 0.8;
}
.mariposa-1 { left: 3%; top: 5%; }
.mariposa-2 { right: -4%; top: 2%; }
.mariposa-3 { left: -5%; top: 15%; }
.mariposa-4 { right: -2%; top: 20%; }

/* RAMAS / PÉTALOS ADICIONALES */
.rama {
  width: min(30vw, 200px);
  opacity: 0.4;
  z-index: 1; /* Al fondo */
  filter: blur(1px) saturate(0.7);
  mix-blend-mode: multiply; /* Mantenido */
}
.rama-der-baja2 { top: 35%; right: -40px; transform: rotate(10deg); }
.rama-der-baja3 { top: 60%; right: -70px; transform: rotate(15deg); }

/* BOLA DISCO (Mantenida por si acaso) */
.bola-izquierda {
  width: 180px;
  left: 20px;
  bottom: 20px;
  z-index: 1;
  opacity: 0.1; /* Muy sutil si no hay background */
  animation: girar-sutil 15s linear infinite;
}
@keyframes girar-sutil {
  0% { transform: rotate(0deg) scale(1); }
  50% { transform: rotate(180deg) scale(1.05); }
  100% { transform: rotate(360deg) scale(1); }
}

/* RESPONSIVE REFINADO */
@media (min-width: 992px) {
  .portada-xv { padding-top: 80px; }
  .imagen-xv-wrapper { margin-top: 0; width: 380px; height: 570px; }
  .texto-xv { margin-top: 40px; }
}

@media (max-width: 768px) {
  .flor { opacity: 0.3; width: min(40vw, 180px); }
  .mariposa { opacity: 0.5; width: min(12vw, 50px); }
}

/* SECCIÓN PADRINOS */
.padrinos-container {
  margin: 28px 0 16px;
  padding: 0 10px;
}

.titulo-padrinos {
  font-family: "Playfair Display", serif;
  font-size: clamp(20px, 3.2vw, 26px);
  color: #5b5a5a;
  font-weight: 600;
  margin-bottom: 12px;
  letter-spacing: 0.5px;
}

.nombre-padrino {
  font-family: "titulos", cursive; /* Asegúrate que esta font esté cargada */
  font-size: clamp(36px, 7vw, 45px);
  color: #6b7c6d;
  margin: 0 0 10px 0;
  line-height: 1.1;
  font-weight: normal;
}

.rol-padrino {
  color: #6b7c6d;
  font-weight: 600;
}

.great {
font-family: "Great Vibes", cursive; 
  color: #6b7c6dc0;                  /* Tono acento verde/olivo de la invitación */
  line-height: 1;
  display: inline-block;
  vertical-align: baseline;
}
</style>